import classNames from "classnames";
import React from "react";

type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export const Button = ({ className, children, ...rest }: ButtonProps) => {
  return (
    <button
      {...rest}
      className={classNames(
        "text-emphasis border-default bg-default hover:bg-muted hover:border-emphasis focus-visible:bg-subtle focus-visible:ring-empthasis disabled:border-subtle disabled:text-muted disabled:hover:text-muted disabled:hover:border-subtle disabled:hover:bg-default relative inline-flex h-9 items-center whitespace-nowrap rounded-md border px-4 py-1 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:bg-opacity-30 disabled:hover:bg-opacity-30",
        className
      )}>
      {children}
    </button>
  );
};

export default Button;
